import React, { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { rolesConfig } from '../rolesConfig';

export default function AuthCallback() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

  useEffect(() => {
    fetch(`${backendUrl}/api/auth/me`, {
      credentials: 'include',
    })
      .then((res) => {
        if (!res.ok) throw new Error('Authentication failed');
        return res.json();
      })
      .then((user) => {
        const role = user.role || user.clientRole || 'Viewer';
        const landingRoute = rolesConfig[role]?.landingRoute ?? '/dashboard';
        queryClient.invalidateQueries({ queryKey: [`${backendUrl}/api/auth/me`] });
        navigate(landingRoute, {
          replace: true,
        });
      })
      .catch((err) => {
        console.error('Auth callback error:', err);
        navigate('/?error=auth_failed', {
          replace: true,
        });
      });
  }, [navigate, queryClient, backendUrl]);

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
        fontFamily: 'var(--px-font, system-ui, sans-serif)',
        color: 'var(--px-text-secondary, #555)',
      }}
    >
      <Loader2 size={36} style={{ animation: 'spin 1s linear infinite', color: 'var(--px-primary, #2563eb)' }} />
      <p style={{ margin: 0, fontSize: '15px', fontWeight: 500 }}>Finalising login…</p>
    </div>
  );
}
